import { Icon } from '@dynamic/ui';
import styled from 'styled-components';

import { remify } from '#/service/utils';

import Button from '../Button/Button';
import { FillDiv } from '../common';

export const OverlayDiv = styled(FillDiv)`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;
OverlayDiv.displayName = 'OverlayDiv';

export const DialogDiv = styled.div`
  width: 40%;
  min-width: min(35rem, 90%);
  max-width: ${remify(1000)};
  box-sizing: border-box;
  padding: 1.5rem;
  text-align: center;
`;
DialogDiv.displayName = 'DialogDiv';

export const StatusIcon = styled(Icon)`
  height: ${remify(104)};
  width: auto;
`;
StatusIcon.displayName = 'StatusIcon';

export const StatusTitle = styled.h2`
  margin: 1rem 0;
  color: ${({ color }) => color};
`;
StatusTitle.displayName = 'StatusTitle';

export const StatusError = styled.p`
  font-size: 0.7rem;
  opacity: 0.3;
  font-family: monospace;
`;
StatusError.displayName = 'StatusError';

export const DialogButton = styled(Button)`
  display: initial;
  margin: 0.5rem 0;
  width: 50%;

  @media (max-width: 400px) {
    width: 100%;
  }
`;
DialogButton.displayName = 'DialogButton';
